// Adding links under search bar
(() => {
  const searchBar = document.querySelector('header section.search');
  if (!searchBar) return;

  const searchBarLinks = document.createElement('div');
  searchBarLinks.classList.add('search-bar-links');

  const quicklists = document.querySelector('.vuequicklistdropdown_elem');
  if (quicklists) {
    searchBarLinks.insertAdjacentElement('afterbegin', quicklists);
  }

  const quote = document.createElement('a');
  quote.href = '/customer/salesquote/new';
  quote.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="1.15 0.47 11.7 14.07" width="14" height="15"><g clip-path="url(#a)"><path fill="#000" d="M11.637 3.73 9.604 1.696A4.057 4.057 0 0 0 6.717.5H4.083a2.92 2.92 0 0 0-2.916 2.917v8.167A2.92 2.92 0 0 0 4.083 14.5h5.834a2.92 2.92 0 0 0 2.916-2.916V6.617a4.056 4.056 0 0 0-1.196-2.887Zm-.824.824c.178.184.33.39.455.613H8.75a.583.583 0 0 1-.583-.583V2.065c.223.125.429.278.612.456l2.034 2.033Zm.854 7.03a1.75 1.75 0 0 1-1.75 1.75H4.083a1.75 1.75 0 0 1-1.75-1.75V3.417a1.75 1.75 0 0 1 1.75-1.75h2.634c.096 0 .188.019.283.027v2.89a1.75 1.75 0 0 0 1.75 1.75h2.89c.008.094.027.186.027.283v4.967ZM9.756 8.265a.583.583 0 0 1-.02.824l-2.094 1.992a1.75 1.75 0 0 1-2.466-.01l-.898-.802a.584.584 0 1 1 .777-.871l.925.825a.584.584 0 0 0 .849.023l2.1-2.001a.583.583 0 0 1 .827.02Z"></path></g><defs><clipPath id="a"><path fill="#fff" d="M0 .5h14v14H0z"></path></clipPath></defs></svg>Request a quote';
  searchBarLinks.insertAdjacentElement('afterbegin', quote);

  searchBar.insertAdjacentElement('beforeend', searchBarLinks);
})();
